import BasePagination from "./BasePagination.vue";

export * from "./types";
export default BasePagination;
